import API from 'services/api';

export const getCalculationLogDocument = (calculationId: string, logId: string): Promise<any> =>
  API.get(`/api/accommodation/calculations/${calculationId}/logs/${logId}/document`, {
    responseType: 'blob',
  }).then(response => response?.data);
